import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "components/basic/button";
import { useDeleteAccountMutation } from "generated/graphql";
import { useSnack } from "hooks/useSnack";

/** Permanently deletes the signed-in account after a confirmation. */
const DeleteAccountButton: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation("profile");
  const navigate = useNavigate();
  const showSnack = useSnack();
  const [, deleteAccount] = useDeleteAccountMutation();
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleDelete = async () => {
    const result = await deleteAccount({});
    if (result.data?.deleteAccount) {
      showSnack(t("delete_account.deleted"), "success");
      navigate("/");
    } else {
      showSnack(t("delete_account.failed"), "error");
    }
    setConfirmOpen(false);
  };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          color="error"
          variant="contained"
          style={{ color: theme.palette.common.white, fontWeight: "bold" }}
          onClick={() => setConfirmOpen(true)}
        >
          {t("delete_account.button")}
        </Button>
      </div>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>{t("delete_account.button")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("delete_account.body")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>
            {t("delete_account.cancel")}
          </Button>
          <Button color="error" variant="contained" onClick={handleDelete}>
            {t("delete_account.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteAccountButton;
